var scope_0 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/10219d914064a52f271d050a60c76590.js').default;
var scope_1 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/17d0a4f6b5acdb33bad83952d26a0b25.js').default;
var scope_2 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4d3529c15b3b1068edd11cde76693529.js').default;
var scope_3 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/95afc7e3ece9fb4d4bcf6cede4a0d2c2.js').default;
var scope_4 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dc58f82c666104e5e049397dab41adbc.js').default;
var scope_5 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_6 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f1f1f15d8d184bb39a53cb087a3cb7cb.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6 )
    